import React from 'react';
import styled from 'styled-components';
import {Grid} from '@material-ui/core';
import {AccentColorOptions} from 'epic-ue-theme';
import {Button, Typography, VerticalSpacer} from '../..';

const Styled = styled.div<{active?: boolean}>`
    && {
        button {
            width: 100%;
            &.primary {
                background-color: ${(p) => p.theme.palette.common.black};
                color: ${(p) => p.theme.palette.common.white};
            }
        }
        ${(p) => p.theme.breakpoints.up('md')} {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
        }
    }
`;

export interface LicensePriceButtonProps {
    className?: string;
    accentColor?: AccentColorOptions;
    active?: boolean;
    price?: string;
    priceNote?: string;
    buttonText?: string;
    buttonHref?: string;
}

export const LicensePriceButton = ({
    className,
    accentColor = 'sky',
    active,
    price = '$0',
    priceNote,
    buttonText = 'Buy Now',
    buttonHref
}: LicensePriceButtonProps): JSX.Element => {
    return (
        <Styled className={`${className || ''} License-price-button`}>
            {price && (
                <>
                    <VerticalSpacer variant="custom" spacing={5} downSmSpacing={4} />
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="flex-end"
                        spacing={2}>
                        <Grid item xs={'auto'}>
                            <Typography variant="h2" big color={accentColor} as="span">
                                {price}
                            </Typography>
                        </Grid>
                        <Grid item xs={true}>
                            <Typography variant="p" caption color={accentColor}>
                                {priceNote}
                            </Typography>
                        </Grid>
                    </Grid>
                </>
            )}
            {buttonHref && (
                <>
                    <VerticalSpacer variant="heading" />
                    <Button
                        type={active ? 'primary' : 'secondary'}
                        color={accentColor}
                        href={buttonHref}>
                        {buttonText}
                    </Button>
                </>
            )}
        </Styled>
    );
};
